<template>
    <div class="container" style="margin-top:40px;">
        <div class="md-layout-item md-size-66 mx-auto md-small-size-100" style="border-style: ridge;">  
            <v-row row no-gutters style="border-bottom-style: ridge;">
                <v-col class="col align-self-center">
                    <div class="labelDiv">
                        Via Whatsapp 
                    </div> 
                    <div class="conteudoDiv">   
                        <fa-icon :icon="['fab', 'whatsapp' ]"/> (31) 99612-8612  <br>   
                        <fa-icon :icon="['fab', 'whatsapp' ]"/> (31) 97150-7147 
                    </div>
                </v-col>
            </v-row> 
            <v-row row no-gutters>
                <v-col class="col align-self-center">
                    <div class="labelDiv">
                        Via E-Mail
                    </div>
                    <div class="conteudoDiv">
                        <fa-icon :icon="['fas', 'envelope' ]"/>  comercial@centergeo.com.br
                    </div>
                </v-col>
            </v-row> 
        </div>
    </div>
</template>

<script>
export default {
    name: "orcamento",
     data() {
        return {
        firstname: null,
        email: null,
        telefone: null,
        leafShow: false,
        mensagem: null
        };
    },
}
</script>

<style scoped>

.md-field.md-theme-default.md-focused .md-input, 
.md-field.md-theme-default.md-focused .md-textarea, 
.md-field.md-theme-default.md-highlight .md-input, 
.md-field.md-theme-default.md-highlight .md-textarea {
    color: #f7b71e !important;
}

.md-field:before {
    background-color: #f7b71e !important;
}

.md-field.md-focused > 
.fa, .md-field.md-focused > 
.md-icon, .md-field.md-focused > 
.fas, .md-field.md-focused > .fab {
    color: #f7b71e !important;
}

.md-button.md-success.md-simple{
    color: #f7b71e !important;
}

.md-field.md-has-textarea:not(.md-autogrow) 
.md-textarea {
    min-height: 135px;
}

.md-field.md-has-textarea:not(.md-autogrow):before {
    border-color: #f7b71e !important;
}

.md-button.md-success.md-simple, 
.md-button.md-success.md-simple:hover, 
.md-button.md-success.md-simple:focus, 
.md-button.md-success.md-simple:active, 
.md-button.md-success.md-simple.active, 
.md-button.md-success.md-simple:active:focus, 
.md-button.md-success.md-simple:active:hover, 
.md-button.md-success.md-simple.active:focus, 
.md-button.md-success.md-simple.active:hover, 
.open > .md-button.md-success.md-simple.dropdown-toggle, 
.open > .md-button.md-success.md-simple.dropdown-toggle:focus, 
.open > .md-button.md-success.md-simple.dropdown-toggle:hover  {
    color: #f7b71e !important;
}

.labelDiv {
    font-weight: bold;
    margin: 15px;
}

.conteudoDiv {
    margin-bottom: 10px;
}
</style>

<!-- <md-field class="md-form-group" slot="inputs">
    <md-icon><fa-icon :icon="['fas', 'user' ]"/></md-icon>
    <label>Nome</label>
    <md-input v-model="firstname"></md-input>
</md-field>
<md-field class="md-form-group" slot="inputs">
    <md-icon><fa-icon :icon="['fas', 'envelope' ]"/></md-icon>
    <label>E-mail</label>
    <md-input v-model="email" type="email"></md-input>
</md-field>
<md-field class="md-form-group" slot="inputs">
    <md-icon><fa-icon :icon="['fas', 'phone' ]"/></md-icon>
    <label>Telefone</label>
    <md-input v-model="telefone"></md-input>
</md-field> -->

<!--  <v-col cols="12">    
    <md-field class="md-form-group" slot="inputs">
        <label style="padding-left: 35px;">Mensagem</label>
        <md-textarea v-model="mensagem"></md-textarea>
    </md-field> 
</v-col>
<v-col cols="12" style="background-color:black;">                    
    <md-button slot="footer" class="md-simple md-success md-lg">
        ENVIE SEU ORÇAMENTO
    </md-button>
</v-col> -->